export const CLEAR = 'CLEAR';
export const SHOW_ARCHIVED_LEADS = 'SHOW_ARCHIVED_LEADS';
export const LEAD_ALERT_STATUS = 'LEAD_ALERT_STATUS';
export const LEAD_ALERT_CONTROL = 'LEAD_ALERT_CONTROL';
export const SELECTED_LEADS = 'SELECTED_LEADS';
export const CLEAR_SELECTED_LEADS = 'CLEAR_SELECTED_LEADS';
export const ADD_LEAD = 'ADD_LEAD';
export const BULK_BUY = 'BULK_BUY';
export const AVAILABILITY_CHECK = 'AVAILABILITY_CHECK';
export const NOT_AVAILABLE = 'NOT_AVAILABLE';
export const PRE_SELECT = 'PRE_SELECT';
export const PRE_SELECT_REJECT = 'PRE_SELECT_REJECT';
export const ACTIVE_LEAD = 'ACTIVE_LEAD';
export const LEAD_NOTIFICATIONS = 'LEAD_NOTIFICATIONS';
export const ACTIONED_LEADS = 'ACTIONED_LEADS';
export const ORIGIN = 'ORIGIN';
export const LEAD_NOTIFICATION_INTERVAL = 'ORIGIN';
